// Auto-save utility to save current section before navigating
// This is triggered when user clicks on a different section in the progress bar

export async function saveSectionBeforeNavigation(sectionNumber) {
  // try {
  //   // console.log(`Auto-saving Section ${sectionNumber} before navigation...`);
  //   // Trigger the save button click event for the current section
  //   // Each section has a save button that handles validation and saving
  //   const saveButton = document.querySelector('button[type="submit"]');
  //   if (saveButton) {
  //     // Programmatically click the save button
  //     saveButton.click();
  //     // Wait a bit for the save to complete
  //     await new Promise((resolve) => setTimeout(resolve, 500));
  //   //   console.log(`Section ${sectionNumber} auto-saved successfully`);
  //   } else {
  //   //   console.warn(`No save button found for Section ${sectionNumber}`);
  //   }
  // } catch (error) {
  //   // console.error(`Error auto-saving Section ${sectionNumber}:`, error);
  // }
}
